// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/obstructions-to-vision.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/obstructions-to-vision/blowing-snow-and-drifting.js';
import g1 from '../lessons/meteorology/obstructions-to-vision/haze-description.js';
import g2 from '../lessons/meteorology/obstructions-to-vision/obstructions-to-vision.js';

mount([g0, g1, g2]);
